import tesla from "./desktop/tesla.svg";
import microsoft from "./desktop/microsoft.svg";
import hp from "./desktop/hewlett-packard.svg";
import oracle from "./desktop/oracle.svg";
import google from "./desktop/google.svg";
import nvidia from "./desktop/nvidia.svg";

import teslaWhite from "./desktop/tesla--white.svg";
import microsoftWhite from "./desktop/microsoft--white.svg";
import hpWhite from "./desktop/hewlett-packard--white.svg";
import oracleWhite from "./desktop/oracle--white.svg";
import googleWhite from "./desktop/google--white.svg";
import nvidiaWhite from "./desktop/nvidia--white.svg";

export const partnersDark = [tesla, microsoft, hp, oracle, google, nvidia];

export const partnersWhite = [
  teslaWhite,
  microsoftWhite,
  hpWhite,
  oracleWhite,
  googleWhite,
  nvidiaWhite,
];
